<!-- home -->
<div class="menu-item">
  <a class="menu-link py-4 mb-2 without-sub" aria-haspopup="true" routerLinkActive="active" routerLink="/Admin/Home">
    <span class="menu-icon">
      <span [inlineSVG]="'./src/assets/images/menu/Home.svg'" class="svg-icon svg-icon-2 svg-icon-dark"></span>
    </span>
    <span class="menu-title">{{getResourceValue("Home")}}</span>
  </a>
</div>
<!-- users -->
<div class="menu-item">
  <a class="menu-link py-4 mb-2 without-sub" aria-haspopup="true" routerLinkActive="active" routerLink="/Admin/Users">
    <span class="menu-icon">
      <span [inlineSVG]="'./src/assets/images/menu/user.svg'" class="svg-icon svg-icon-2 svg-icon-dark"></span>
    </span>
    <span class="menu-title">{{getResourceValue("Users")}}</span>
  </a>
</div>
<!-- Active Directory -->
<div class="menu-item">
  <a class="menu-link py-4 mb-2 without-sub"
     aria-haspopup="true" routerLinkActive="active" routerLink="/Admin/ADConnection">
    <span class="menu-icon">
      <span [inlineSVG]="'./src/assets/images/menu/Folder.svg'" class="svg-icon svg-icon-2 svg-icon-dark"></span>
    </span>
    <span class="menu-title">{{getResourceValue("ActiveDirectory")}}</span>
  </a>
</div>
<!-- Configuration -->
<div class="menu-item">
  <a class="menu-link py-4 mb-2 without-sub"
     aria-haspopup="true" routerLinkActive="active" routerLink="/Admin/Configurations">
    <span class="menu-icon">
      <span [inlineSVG]="'./src/assets/images/menu/Tools.svg'" class="svg-icon svg-icon-2 svg-icon-dark"></span>
    </span>
    <span class="menu-title">{{getResourceValue("Configuration")}}</span>
  </a>
</div>
<!-- Jobs -->
<div class="menu-item">
  <a class="menu-link py-4 mb-2 without-sub"
     aria-haspopup="true" routerLinkActive="active" routerLink="/Admin/Jobs">
    <span class="menu-icon">
      <span [inlineSVG]="'./src/assets/images/menu/Briefcase.svg'" class="svg-icon svg-icon-2 svg-icon-dark"></span>
    </span>
    <span class="menu-title">{{getResourceValue("Jobs")}}</span>
  </a>
</div>
<!-- License -->
<div class="menu-item">
  <a class="menu-link py-4 mb-2 without-sub"
     aria-haspopup="true" routerLinkActive="active" routerLink="/Admin/License">
    <span class="menu-icon">
      <span [inlineSVG]="'./src/assets/images/menu/License.svg'" class="svg-icon svg-icon-2 svg-icon-dark"></span>
    </span>
    <span class="menu-title">{{getResourceValue("License")}}</span>
  </a>
</div>
<!-- Localization -->
<div class="menu-item">
  <a class="menu-link py-4 mb-2 without-sub"
     aria-haspopup="true" routerLinkActive="active" routerLink="/Admin/Localization">
    <span class="menu-icon">
      <span [inlineSVG]="'./src/assets/images/menu/Localization.svg'" class="svg-icon svg-icon-2 svg-icon-dark"></span>
    </span>
    <span class="menu-title">{{getResourceValue("Localization")}}</span>
  </a>
</div>
<!-- Logs -->
<div class="menu-item">
  <a class="menu-link py-4 mb-2 without-sub"
     aria-haspopup="true" routerLinkActive="active" routerLink="/Admin/Logs">
    <span class="menu-icon">
      <span [inlineSVG]="'./src/assets/images/menu/File.svg'" class="svg-icon svg-icon-2 svg-icon-dark"></span>
    </span>
    <span class="menu-title">{{getResourceValue("Logs")}}</span>
  </a>
</div>
<!-- Service Providers -->
<div class="menu-item">
  <a class="menu-link py-4 mb-2 without-sub"
     aria-haspopup="true" routerLinkActive="active" routerLink="/Admin/Providers">
    <span class="menu-icon">
      <span [inlineSVG]="'./src/assets/images/menu/ServiceProvider.svg'" class="svg-icon svg-icon-2 svg-icon-dark"></span>
    </span>
    <span class="menu-title">{{getResourceValue("ServiceProviders")}}</span>
  </a>
</div>
<!-- Public Holidays -->
<div class="menu-item">
  <a class="menu-link py-4 mb-2 without-sub"
     aria-haspopup="true" routerLinkActive="active" routerLink="/Admin/PublicHolidays">
    <span class="menu-icon">
      <span [inlineSVG]="'./src/assets/images/menu/PublicHolidays.svg'" class="svg-icon svg-icon-2 svg-icon-dark"></span>
    </span>
    <span class="menu-title">{{getResourceValue("PublicHolidays")}}</span>
  </a>
</div>
<!-- Workflows -->
<div class="menu-item">
  <a class="menu-link py-4 mb-2 without-sub"
     aria-haspopup="true" routerLinkActive="active" routerLink="/Admin/Workflows">
    <span class="menu-icon">
      <span [inlineSVG]="'./src/assets/images/menu/Workflows.svg'" class="svg-icon svg-icon-2 svg-icon-dark"></span>
    </span>
    <span class="menu-title">{{getResourceValue("Workflows")}}</span>
  </a>
</div>
<!-- Roles -->
<div class="menu-item menu-accordion"
     data-kt-menu-trigger="click"
     routerLinkActive="here show">
  <span class="menu-link py-4 mb-2">
    <span class="menu-icon">
      <span class="svg-icon svg-icon-2"
            [inlineSVG]="'./src/assets/images/menu/Roles.svg'"></span>
    </span><span class="menu-title" data-link="/crafted/account">{{getResourceValue("Roles")}}</span><span class="menu-arrow"></span>
  </span>
  <div class="menu-sub menu-sub-accordion" routerLinkActive="menu-active-bg">
    <div class="menu-item">
      <a class="menu-link py-4 mb-2 without-sub"
         routerLinkActive="active"
         routerLink="/Admin/Roles/PermissionSets">
        <span class="menu-bullet"><span class="bullet bullet-dot"></span></span><span class="menu-title">{{getResourceValue("PermissionSets")}}</span>
      </a>
    </div>

  </div>
</div>
<!-- Notifications -->
<div class="menu-item menu-accordion"
     data-kt-menu-trigger="click"
     routerLinkActive="here show">
  <span class="menu-link py-4 mb-2">
    <span class="menu-icon">
      <span class="svg-icon svg-icon-2"
            [inlineSVG]="'./src/assets/images/menu/Notifications.svg'"></span>
    </span><span class="menu-title" data-link="/crafted/account">{{getResourceValue("Notifications")}}</span><span class="menu-arrow"></span>
  </span>
  <div class="menu-sub menu-sub-accordion" routerLinkActive="menu-active-bg">
    <div class="menu-item">
      <a class="menu-link py-4 mb-2 without-sub"
         routerLinkActive="active"
         routerLink="/Admin/Notifications/Templates">
        <span class="menu-bullet"><span class="bullet bullet-dot"></span></span><span class="menu-title">{{getResourceValue("Templates")}}</span>
      </a>
    </div>

  </div>
  <div class="menu-sub menu-sub-accordion" routerLinkActive="menu-active-bg">
    <div class="menu-item">
      <a class="menu-link py-4 mb-2 without-sub"
         routerLinkActive="active"
         routerLink="/Admin/Notifications/MasterLayouts">
        <span class="menu-bullet"><span class="bullet bullet-dot"></span></span><span class="menu-title">{{getResourceValue("EmailHeader&FooterTemplates")}}</span>
      </a>
    </div>

  </div>
</div>
<!-- Lookups -->
<div class="menu-item menu-accordion"
     data-kt-menu-trigger="click"
     routerLinkActive="here show">
  <span class="menu-link py-4 mb-2">
    <span class="menu-icon">
      <span class="svg-icon svg-icon-2"
            [inlineSVG]="'./src/assets/images/menu/Lookups.svg'"></span>
    </span><span class="menu-title" data-link="/crafted/account">Lookups</span><span class="menu-arrow"></span>
  </span>
  <div class="menu-sub menu-sub-accordion" routerLinkActive="menu-active-bg">
    <div class="menu-item">
      <a class="menu-link py-4 mb-2 without-sub"
         routerLinkActive="active"
         routerLink="/Admin/Lookups/Lookups">
        <span class="menu-bullet"><span class="bullet bullet-dot"></span></span><span class="menu-title">{{getResourceValue("Lookup")}}</span>
      </a>
    </div>

  </div>
  <div class="menu-sub menu-sub-accordion" routerLinkActive="menu-active-bg">
    <div class="menu-item">
      <a class="menu-link py-4 mb-2 without-sub"
         routerLinkActive="active"
         routerLink="/Admin/Lookups/LookupGroups">
        <span class="menu-bullet"><span class="bullet bullet-dot"></span></span><span class="menu-title">{{getResourceValue("LookupGroups")}}</span>
      </a>
    </div>

  </div>
</div>
<!-- Impersonation Rules -->
<div class="menu-item">
  <a class="menu-link py-4 mb-2 without-sub"
     aria-haspopup="true" routerLinkActive="active" routerLink="/Admin/ImpersonationRules">
    <span class="menu-icon">
      <span [inlineSVG]="'./src/assets/images/menu/Impersonation.svg'" class="svg-icon svg-icon-2 svg-icon-dark"></span>
    </span>
    <span class="menu-title">{{getResourceValue("ImpersonationRules")}}</span>
  </a>
</div>
<!-- Department -->
<div class="menu-item">
  <a class="menu-link py-4 mb-2 without-sub"
     aria-haspopup="true" routerLinkActive="active" routerLink="/Admin/Departments">
    <span class="menu-icon">
      <span [inlineSVG]="'./src/assets/images/menu/Department.svg'" class="svg-icon svg-icon-2 svg-icon-dark"></span>
    </span>
    <span class="menu-title">{{getResourceValue("Departments")}}</span>
  </a>
</div>
<!-- Sector -->
<div class="menu-item">
  <a class="menu-link py-4 mb-2 without-sub"
     aria-haspopup="true" routerLinkActive="active" routerLink="/Admin/Sectors">
    <span class="menu-icon">
      <span [inlineSVG]="'./src/assets/images/menu/Sectors.svg'" class="svg-icon svg-icon-2 svg-icon-dark"></span>
    </span>
    <span class="menu-title">{{getResourceValue("Sectors")}}</span>
  </a>
</div>
  <!-- Sector -->
<div class="menu-item">
  <a class="menu-link py-4 mb-2 without-sub"
     aria-haspopup="true" routerLinkActive="active" routerLink="/Admin/HelpCenter">
    <span class="menu-icon">
      <span [inlineSVG]="'./src/assets/images/menu/HelpCenter.svg'" class="svg-icon svg-icon-2 svg-icon-dark"></span>
    </span>
    <span class="menu-title">{{getResourceValue("FAQs")}}</span>
  </a>
</div>

